const Hr = () => {
	return <hr className="w-100 text-white my-2" />
}

export default Hr
